import './icater/style';
import FormStructure from './icater/form_structure';

export default FormStructure;